// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ScuIQ","xsFooter":"styles_xsFooter__pFVFX","smFooter":"styles_smFooter__POIRA"};